/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors
 */
export interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'detectedDpi'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'calculatedDpi'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'colorGradation'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'heightMillis'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'widthMillis'?: CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum;
}

export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum];


